import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const useDirectoryDetailStore = defineStore("directoryDetail", {
  state: () => ({
    company: null,
    products: [],
    filteredProducts: [],
    loading: false,
    error: "",
    searchProduct: "",
    searchNandina: "",
    currentPage: 1,
    itemsPerPage: 5,
  }),

  getters: {
    totalPages(state) {
      return Math.ceil(state.filteredProducts.length / state.itemsPerPage) || 1;
    },
    paginatedProducts(state) {
      const start = (state.currentPage - 1) * state.itemsPerPage;
      const end = start + state.itemsPerPage;
      return state.filteredProducts.slice(start, end);
    },
  },

  actions: {
    /**
     * 🔹 Obtener detalle de empresa con productos
     */
    async fetchCompanyDetail(companyId) {
      this.loading = true;
      this.error = "";
      this.company = null;
      this.products = [];
      this.filteredProducts = [];

      try {
        const response = await apiClient.get(`/directory/${companyId}`);
        const data = response.data;

        this.company = {
          id: data.id,
          name: data.name,
          nit: data.nit,
          contact_name: data.contact_name,
          email: data.email,
          phone_number: data.phone_number,
          department: data.department,
          sector: data.sector,
          products_count: data.products_count,
        };

        this.products = data.products ?? [];
        this.filteredProducts = [...this.products];
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          this.error =
            "No se pudo conectar al servidor. Por favor, intenta nuevamente más tarde.";
        } else if (error.response?.status === 404) {
          this.error = "No se encontró la empresa solicitada.";
        } else {
          this.error =
            error.response?.data?.message ||
            "Error al cargar el detalle. Intente de nuevo más tarde.";
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * 🔍 Buscar producto por nombre
     */
    searchByProductName(name) {
      this.searchProduct = name;
      this.searchNandina = "";
      this.currentPage = 1;

      if (!name.trim()) {
        this.filteredProducts = [...this.products];
        return;
      }

      const query = name.toLowerCase();
      this.filteredProducts = this.products.filter((p) =>
        p.name.toLowerCase().includes(query)
      );
    },

    /**
     * 🔍 Buscar producto por código o descripción NANDINA
     */
    searchByNandina(term) {
      this.searchNandina = term;
      this.searchProduct = "";
      this.currentPage = 1;

      if (!term.trim()) {
        this.filteredProducts = [...this.products];
        return;
      }

      const query = term.toLowerCase();
      this.filteredProducts = this.products.filter((p) => {
        const n = p.productonacional?.nandina?.toLowerCase() || "";
        const d = p.productonacional?.desnandina?.toLowerCase() || "";
        return n.includes(query) || d.includes(query);
      });
    },

    /**
     * 🔄 Cambiar de página
     */
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    /**
     * 🔁 Resetear filtros
     */
    resetFilters() {
      this.searchProduct = "";
      this.searchNandina = "";
      this.filteredProducts = [...this.products];
      this.currentPage = 1;
    },
  },
});
